import faker from 'faker';

import {
  IInvoice,
  IInvoiceData,
  IInvoiceItem,
  IInvoiceItemData
} from '../invoice.types';
import { Invoice, InvoiceItem } from '../invoice';
import { createRange } from '@/utils/helpers';

export function createRandomInvoice(): IInvoiceData {
  return {
    id: faker.datatype.number(),
    number: faker.datatype.number(),
    po_number: faker.datatype.string(10),
    csi_order_number: faker.datatype.string(7),
    total_amount_due: faker.datatype.number(),
    due_date: faker.date.past().toISOString(),
    buyer_detail: {
      id: faker.datatype.number(),
      name: faker.random.word(),
      customer_number: faker.datatype.string(8),
      address: {
        id: faker.datatype.number(),
        address1: faker.address.streetAddress(),
        address2: faker.address.secondaryAddress(),
        address3: faker.address.streetName(),
        address4: faker.address.streetSuffix(),
        city: faker.address.city(),
        region: faker.address.state(),
        postal_code: faker.address.zipCode(),
        country: faker.address.country()
      }
    },
    shipping_detail: {
      id: faker.datatype.number(),
      name: faker.random.word(),
      address: {
        id: faker.datatype.number(),
        address1: faker.address.streetAddress(),
        address2: faker.address.secondaryAddress(),
        address3: faker.address.streetName(),
        address4: faker.address.streetSuffix(),
        city: faker.address.city(),
        region: faker.address.state(),
        postal_code: faker.address.zipCode(),
        country: faker.address.country()
      }
    },
    currency: {
      id: faker.datatype.number(),
      code: faker.finance.currencyCode(),
      description: faker.finance.currencyName()
    },
    state: faker.datatype.number(),
    items: mockInvoiceItemsData
  };
}

export const mockInvoicesData: IInvoiceData[] = createRange(5).map(() =>
  createRandomInvoice()
);

export function createRandomInvoiceItem(): IInvoiceItemData {
  return {
    id: faker.datatype.number(),
    description: faker.random.word(),
    term_percentage: faker.finance.amount(),
    price: faker.finance.amount(),
    calculated_amount_due: faker.datatype.number()
  };
}

export const mockInvoiceItemsData: IInvoiceItemData[] = createRange(4).map(() =>
  createRandomInvoiceItem()
);

export const mockInvoices = (
  data: IInvoiceData[] = mockInvoicesData
): IInvoice[] => data.map(item => new Invoice(item));

export const mockInvoiceItems = (
  data: IInvoiceItemData[] = mockInvoiceItemsData
): IInvoiceItem[] => data.map(item => new InvoiceItem(item));

export const mockPaginatedInvoice = {
  count: mockInvoicesData.length,
  next: null,
  previous: null,
  results: mockInvoicesData
};
